<app-module-header [title]="organization.organizationName + ' - ' + ('KEY_TASKS.USER' | transloco)"
  [icon]="'people'"></app-module-header>

<mat-progress-bar mode="indeterminate" class="mb-2" *ngIf="loading"></mat-progress-bar>

<div *ngIf="!loading" class="flex w-full gap-2 h-full min-h-[75vh]">
  <!-- Left: Organizations List (1/4) -->
  <div class="w-1/4 bg-gray-100 border-r">

    <div>
      <div class="org-list-container">
        @for (org of organizations; track org.id) {
        <div class="flex items-center"
          [ngStyle]="{'margin-left': org.id != organization.organizationId ? '2rem' : '0rem'}">
          <mat-icon *ngIf="org.id != organization.organizationId" class="return-icon"
            aria-hidden="false" aria-label="next icon">keyboard_return</mat-icon>
          <div class="mx-3 my-2 p-2 cursor-pointer bg-white w-full org-item-border" [ngClass]="{
                    'selected-org': selectedOrg?.id === org.id, 'sub-org': org.id != organization.organizationId}"
            (click)="selectOrganization(org)">{{org.name}}
          </div>
        </div>
        }
      </div>
    </div>
    <div *ngIf="hasParkingOperatorRole" class="m-3 p-2 cursor-pointer text-center bg-[#e3f2fd] add-org-button"
      (click)="addNewOrganization()">+ Add New
      Organization</div>
  </div>

  <!-- Right: Organization Details (3/4) -->
  <div class="w-3/4 bg-gray-100 border-r p-4 pt-0">
    <mat-tab-group *ngIf="selectedOrg">
      <mat-tab label="Users">
        <!-- Users Content -->
        <div class="mt-3">
          <div class="flex justify-end mb-3">
            <div class="flex gap-2">
              <div class="my-3 p-2 clickable text-center bg-[#e3f2fd] add-user-button" 
                (click)="addNewUser()">+ Add New
                User</div>
              <div class="m-3 p-2 cursor-pointer text-center bg-[#e3f2fd] add-user-button" (click)="addExistingUser()">
                + Add Existing
                User</div>
            </div>
          </div>
          <div class="filter-container">
            <!-- Search Field -->
            <div class="search-field">
              <mat-label class="hidden-label">.</mat-label>
              <mat-form-field appearance="outline" class="">
                <mat-label>{{ 'USER_MANAGEMENT.SEARCH_USERS' | transloco }}</mat-label>
                <input matInput [placeholder]="'USER_MANAGEMENT.SEARCH_PLACEHOLDER' | transloco"
                  [(ngModel)]="searchQuery" (input)="filterUsers()">
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
            </div>

            <!-- Membership Type -->
            <div class="filter-group gate-filter-container multiple-select">
              <mat-label>{{ 'USER_MANAGEMENT.MEMBERSHIP_TYPE' | transloco }}</mat-label>
              <mat-form-field>
                <mat-select [value]="selectedMembershipTypes" (selectionChange)="onMembershipTypeChange($event)"
                  multiple>
                  <mat-option *ngFor="let type of organizationMemberTypes" [value]="type.value">
                    {{type?.translation | transloco}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

          </div>

          <div class="custom-table-container"
            *ngIf="selectedOrg.members && selectedOrg.members.length > 0; else noUsers">
            <table class="custom-table col-xs-6 w-full" mat-table [dataSource]="filteredOrgUsers"
              class="mat-elevation-z1">
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef
                  [ngStyle]="selectedOrg.id === 'a848ccd3-fd8d-4035-925e-571ebb4e93e8' ? { width: '140px', minWidth: '100px' } : {}">
                  Name
                </th>
                <td mat-cell *matCellDef="let user" class="table-cell-pointer"
                  [ngStyle]="selectedOrg.id === 'a848ccd3-fd8d-4035-925e-571ebb4e93e8' ? { width: '140px', minWidth: '100px' } : {}">
                  {{ user.firstname + " " + user.lastname }}
                </td>
              </ng-container>

              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef
                  [ngStyle]="selectedOrg.id === 'a848ccd3-fd8d-4035-925e-571ebb4e93e8' ? { width: '300px', minWidth: '160px' } : {}">
                  Email
                </th>
                <td mat-cell *matCellDef="let user" class="table-cell-pointer"
                  [ngStyle]="selectedOrg.id === 'a848ccd3-fd8d-4035-925e-571ebb4e93e8' ? { width: '300px', minWidth: '160px' } : {}">
                  {{ user.email }}
                </td>
              </ng-container>

              <ng-container matColumnDef="memberTypeNames">
                <th mat-header-cell *matHeaderCellDef class="membership-header">
                  Membership Type </th>
                <td mat-cell *matCellDef="let user" class="membership-cell">
                  <mat-chip-set *ngIf="user.memberTypeNamesArray && user.memberTypeNamesArray.length"
                    class="chip-list-horizontal">
                    <mat-chip *ngFor="let item of user.memberTypeNamesArray">
                      <div class="chips">{{ item?.translation ? (item?.translation | transloco) : item?.value }}</div>
                    </mat-chip>
                  </mat-chip-set>
                </td>
              </ng-container>

              <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef class="edit-header"></th>
                <td mat-cell *matCellDef="let user" class="edit-cell">
                  <button mat-icon-button>
                    <mat-icon class="edit-icon">edit</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="['name', 'email', 'memberTypeNames', 'edit']"></tr>
              <tr class="table-row-pointer" mat-row
                *matRowDef="let row; columns: ['name', 'email', 'memberTypeNames', 'edit'];"
                (click)="onEditMemberTypes(row)">
              </tr>
            </table>
          </div>
          <ng-template #noUsers>
            <div class="coming-soon-container no-users-container" (click)="addExistingUser()">
              <mat-card class="coming-soon-card">
                <mat-card-content>
                  <p>No users found for the selected organization</p>
                </mat-card-content>
              </mat-card>
            </div>
          </ng-template>
        </div>
      </mat-tab>
      <mat-tab label="Info">
        <div class="mt-3 p-4 border bg-white info-card">
          <h3 class="font-semibold text-xl mb-3 info-title">{{ selectedOrg.name }}</h3>
          <p class="text-black mb-2"><span class="font-medium">ID:</span> {{ selectedOrg.id }}</p>
          <p class="text-black mb-2"><span class="font-medium">Type:</span> {{ selectedOrg.type }}</p>
          <p class="text-black mb-2"><span class="font-medium">Members:</span> {{
            selectedOrg.members?.length }}
          </p>

          <div *ngIf="selectedOrg.type === 'ShuttleCustomer'" class="d-flex align-items-center shuttle-booking-controls">
            <mat-form-field appearance="outline">
              <mat-label>Shuttle Booking Allowed Until</mat-label>
              <input matInput [matDatepicker]="shuttleBookingAllowedUntilPicker"
                [(ngModel)]="selectedOrg.shuttleBookingAllowedUntil" placeholder="No limit set">
              <mat-datepicker-toggle matSuffix [for]="shuttleBookingAllowedUntilPicker"></mat-datepicker-toggle>
              <mat-datepicker #shuttleBookingAllowedUntilPicker></mat-datepicker>
            </mat-form-field>
            <button mat-stroked-button color="warn" type="button"
              (click)="selectedOrg.shuttleBookingAllowedUntil = null"
              [disabled]="!selectedOrg.shuttleBookingAllowedUntil">Clear</button>
            <button mat-flat-button color="primary" type="button"
              (click)="saveShuttleBookingAllowedUntil()">Save</button>
          </div>
        </div>

        <div *ngIf="selectedOrg.type === 'ParkingCompany'" class="parkings-container p-4">
          <h3 class="font-semibold text-xl mb-4 parking-title">Parking Permissions</h3>

          <div class="overflow-x-auto bg-white rounded-lg ">
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Parking Name
                  </th>
                  <th scope="col"
                    class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Subscription
                  </th>
                  <th scope="col"
                    class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Vehicle
                  </th>
                  <th scope="col"
                    class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Maintenance
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr *ngFor="let parking of parkingData" [class.bg-blue-50]="parking.isEditing">
                  <td class="px-6 py-4 whitespace-nowrap">
                    <div class="flex items-center">
                      <mat-icon class="mr-2">local_parking</mat-icon>
                      <div class="text-sm font-medium text-gray-900">{{parking.parkingName}}</div>
                    </div>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-center">
                    <mat-checkbox [checked]="parking?.access?.subscription" [disabled]="!parking.isEditing"
                      (change)="onPermissionChange(parking, 'subscription', $event.checked)">
                    </mat-checkbox>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-center">
                    <mat-checkbox [checked]="parking.access?.vehicle" [disabled]="!parking.isEditing"
                      (change)="onPermissionChange(parking, 'vehicle', $event.checked)">
                    </mat-checkbox>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-center">
                    <mat-checkbox [checked]="parking.access?.maintenance" [disabled]="!parking.isEditing"
                      (change)="onPermissionChange(parking, 'maintenance', $event.checked)">
                    </mat-checkbox>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="mt-4 flex justify-end">
            <button *ngIf="!isEditing" mat-raised-button color="primary" (click)="startEditing()">
              <mat-icon>edit</mat-icon> Edit Permissions
            </button>
            <div *ngIf="isEditing" class="space-x-2">
              <button mat-button (click)="cancelEditing()">
                Cancel
              </button>
              <button mat-raised-button color="primary" (click)="savePermissions()" [disabled]="!hasChanges">
                <mat-icon>save</mat-icon> Save Changes
              </button>
            </div>
          </div>
        </div>

      </mat-tab>
    </mat-tab-group>
    <div *ngIf="!selectedOrg" class="text-gray-500 text-center mt-10">Select an organization to view details.</div>
  </div>
</div>